import $ from 'jquery';
import ComponentBasePrototype from 'ComponentBasePrototype';

/**
 * Component SubNavigation
 */
export default class SubNavigation extends ComponentBasePrototype {

  build() {
    this.selectors = {
      iconSelector: '.sub-nav__icon',
      listSelector: '.sub-nav__list',
      activeLinkSelector: '.sub-nav__link--active',
    };
    this.classNames = {
      listScrollLeft: 'sub-nav__list--scrollLeft',
      listScrollRight: 'sub-nav__list--scrollRight',
      arrowIconLeft: 'sub-nav__icon--left',
      arrowIconRight: 'sub-nav__icon--right',
    };

    this.icons = this.node.find(this.selectors.iconSelector);
    this.list = this.node.find(this.selectors.listSelector);
    this.activeLink = this.list.find(this.selectors.activeLinkSelector);

    // List not found
    if (!this.list.length) {
      return;
    }

    this.setHandlers();
    this.showActiveLink();
    this.scrollList();
  }

  showActiveLink() {
    if (this.activeLink.length > 0) {
      this.list[0].scrollLeft = this.activeLink[0].offsetLeft - this.activeLink.width();
    }
  }

  setHandlers() {
    this.list.on('scroll', () => {
      this.scrollList();
    });

    $(window).on('resize', () => {
      this.scrollList();
    });

    this.icons.on('click', (event) => {
      this.handleClickIcon($(event.currentTarget));
    });
  }

  scrollList() {
    this.clientWidth = $(window).width();

    // Position left arrow to be visible if the element position is
    // more than 5 px from the left edge
    if (this.list[0].scrollLeft > 5) {
      this.list.addClass(this.classNames.listScrollLeft);
    } else {
      this.list.removeClass(this.classNames.listScrollLeft);
    }

    // Position right arrow to be visible if the element position to he right is
    // less than the scrollable distance - element width
    if ((this.clientWidth < this.list[0].scrollWidth
          && this.list[0].scrollLeft >= this.list[0].scrollWidth)
        || this.list[0].scrollLeft < this.list[0].scrollWidth - this.list[0].offsetWidth - 5) {
      this.list.addClass(this.classNames.listScrollRight);
    } else {
      this.list.removeClass(this.classNames.listScrollRight);
    }
  }

  handleClickIcon(icon) {
    // Click left arrow
    if (icon.hasClass(this.classNames.arrowIconLeft)) {
      // Scroll if more than clientWidth is scrollable, otherwise scroll to the end
      if (this.list[0].scrollLeft >= (this.clientWidth / 2)) {
        this.list.animate({ scrollLeft: this.list[0].scrollLeft - (this.clientWidth / 2) }, 250);
      } else {
        this.list.animate({ scrollLeft: 0 }, 250);
      }
    } else if (icon.hasClass(this.classNames.arrowIconRight)) {      // Click right arrow
      // Scroll if more than clientWidth is scrollable, otherwise scroll to the end
      if (this.list[0].scrollLeft <
          this.list[0].scrollWidth - this.list[0].offsetWidth - (this.clientWidth / 2)) {
        this.list.animate({ scrollLeft: this.list[0].scrollLeft + (this.clientWidth / 2) }, 250);
      } else {
        this.list.animate({ scrollLeft: this.list[0].scrollWidth - this.list[0].offsetWidth }, 250);
      }
    }
  }
}
